<template>
  <div style="margin: 0 auto; max-width: 960px;">
    <DashboardNav />
    <main class="user-settings">
      <section class="accordions">
        <div class="accordion">
          <div class="title" @click="toggleAccordion">Rallyhood Profile</div>
          <UserProfile @saveComplete="reloadAfterAvatarUpdate"></UserProfile>
        </div>
        <div class="accordion email-addresses">
          <div class="title" @click="toggleAccordion">Email Addresses</div>
          <EmailAddresses @saveComplete="collapseAccordion"></EmailAddresses>
        </div>
        <div class="accordion">
          <div class="title" @click="toggleAccordion">Notification Settings</div>
          <NotificationSettings @saveComplete="collapseAccordion"></NotificationSettings>
        </div>
        <div v-if="blockedUserIds.length > 0" class="accordion" ref="blockedUsersAccordion">
          <div class="title" @click="toggleAccordion">Blocked Users</div>
          <div class="body">
            <BlockedUsersList></BlockedUsersList>
          </div>
        </div>
        <div class="accordion">
          <div class="title" @click="toggleAccordion">Daily Digest</div>
          <DigestSettings @saveComplete="collapseAccordion"></DigestSettings>
        </div>
        <div class="accordion archive-delete">
          <div class="title" @click="toggleAccordion">Change Password</div>
          <ChangePassword @saveComplete="collapseAccordion"></ChangePassword>
        </div>
        <div class="accordion archive-delete">
          <div class="title" @click="toggleAccordion">Manage Account</div>
          <ManageAccount @saveComplete="collapseAccordion"></ManageAccount>
        </div>
      </section>
    </main>
  </div>
</template>

<script>

import { mapGetters } from "vuex";
import UxMixin from "../components/UxMixin";
import BlockedUsersList from "../components/BlockedUsersList.vue";
import { eventBus } from "../main.js";

export default {
  components: { BlockedUsersList },
  data: function() {
    return {
      user_id: null,
    };
  },

  mixins: [UxMixin],
  mounted() {
    // /settings?open=blocked (from messaging's "View Blocked Users") lands
    // with the Blocked Users accordion expanded.
    if (this.$route?.query?.open === 'blocked' && this.$refs.blockedUsersAccordion) {
      this.$refs.blockedUsersAccordion.classList.add('open');
    }
  },
  computed: {
    ...mapGetters("blockedUsers", ["blockedUserIds"]),
  },
  methods: {
    async reloadAfterAvatarUpdate(){
      eventBus.emit('overlayOn')
      await  new Promise(resolve => setTimeout(resolve, 8000));
      eventBus.emit('overlayOff')
      location.reload()
    },
    collapseAccordion() {
      const accordions = this.$el.getElementsByClassName('accordion');
      Array.from(accordions).forEach((accordion) => {
        accordion.classList.remove('open');
      });
      // Scroll to the top of the page
      window.scrollTo(0, 0);
    },
  },
};
</script>
